import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CIVILPROGRESSION,
  DELETE_CIVILPROGRESSION,
  UPDATE_CIVILPROGRESSION,
  ADD_NEW_CIVILPROGRESSION,
} from "./actionType";

import {
  getCivilProgressionSuccess,
  getCivilProgressionFail,
  deleteCivilProgressionSuccess,
  deleteCivilProgressionFail,
  updateCivilProgressionSuccess,
  updateCivilProgressionFail,
  addCivilProgressionSuccess,
  addCivilProgressionFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getCivilProgressionApi,
  updateCivilProgressionApi,
  deleteCivilProgressionApi,
  addNewCivilProgressionApi,
  approveCivilProgressionApi
} from "../../helpers/backend_helper";

function* getCivilProgression({ payload: civilProgression }) {
  try {
    const response = yield call(getCivilProgressionApi, civilProgression);
    yield put(getCivilProgressionSuccess(GET_CIVILPROGRESSION, response.data));
  } catch (error) {
    yield put(getCivilProgressionFail(GET_CIVILPROGRESSION, error));
  }
}

function* onUpdateCivilProgression({ payload: civilProgression }) {
  try {
    if (civilProgression.setApprove) {
      const response = yield call(approveCivilProgressionApi, civilProgression);
      yield put(updateCivilProgressionSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCivilProgressionApi, civilProgression);
      yield put(updateCivilProgressionSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCivilProgressionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCivilProgression({ payload: civilProgression }) {
  try {
    const response = yield call(deleteCivilProgressionApi, civilProgression);
    yield put(deleteCivilProgressionSuccess({ civilProgression, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCivilProgressionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCivilProgression({ payload: civilProgression }) {
  try {
    const response = yield call(addNewCivilProgressionApi, civilProgression);
    yield put(addCivilProgressionSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCivilProgressionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCivilProgression() {
  yield takeEvery(GET_CIVILPROGRESSION, getCivilProgression);
}

export function* watchUpdateCivilProgression() {
  yield takeEvery(UPDATE_CIVILPROGRESSION, onUpdateCivilProgression);
}

export function* watchDeleteCivilProgression() {
  yield takeEvery(DELETE_CIVILPROGRESSION, onDeleteCivilProgression);
}

export function* watchAddNewCivilProgression() {
  yield takeEvery(ADD_NEW_CIVILPROGRESSION, onAddNewCivilProgression);
}

function* civilProgressionSaga() {
  yield all([
    fork(watchGetCivilProgression),
    fork(watchDeleteCivilProgression),
    fork(watchUpdateCivilProgression),
    fork(watchAddNewCivilProgression)
  ]);
}

export default civilProgressionSaga;
